import ErrorLog, { LogLevel } from "./models/ErrorLog";

export const getEnvKey = (key: string): string | undefined => {
  if(Object.keys(process.env).length < 1) {
    ErrorLog.log(new Error(), 'no .env values set', LogLevel.info);
    return;
  }

  const value = process.env[key];
  if (value === undefined) {
    const message = `Missing required environment variable ${key}`
    ErrorLog.log(new Error(message), message, LogLevel.info)
  }
  return value;
}
export const getEnv = () => {
  return getEnvKey('NODE_ENV')
}

// environment-level feature flag, controlled by ENV variable
// enable feature `key` by setting ENV variable to a truthy value other than string 'null' (which signifies feature disabled)
export const featureEnabled = (key: string): boolean => {
  const val = getEnvKey(key)
  const enabled = val ? val !== 'null' : false
  if(process.env.REACT_APP_ENVIRONMENT === "local") {
    console.log(`dev log: featureEnabled check for ${key}. Enabled?`, enabled)
  }
  return enabled
}